export const checkIsAdmin = (isAdmin, userType) => {
  return isAdmin && userType === "Admin";
}